"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Coordinates$ = exports.Coordinates$outboundSchema = exports.Coordinates$inboundSchema = void 0;
exports.coordinatesToJSON = coordinatesToJSON;
exports.coordinatesFromJSON = coordinatesFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.Coordinates$inboundSchema = z.object({
    latitude: z.nullable(z.number()),
    longitude: z.nullable(z.number()),
});
/** @internal */
exports.Coordinates$outboundSchema = z.object({
    latitude: z.nullable(z.number()),
    longitude: z.nullable(z.number()),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var Coordinates$;
(function (Coordinates$) {
    /** @deprecated use `Coordinates$inboundSchema` instead. */
    Coordinates$.inboundSchema = exports.Coordinates$inboundSchema;
    /** @deprecated use `Coordinates$outboundSchema` instead. */
    Coordinates$.outboundSchema = exports.Coordinates$outboundSchema;
})(Coordinates$ || (exports.Coordinates$ = Coordinates$ = {}));
function coordinatesToJSON(coordinates) {
    return JSON.stringify(exports.Coordinates$outboundSchema.parse(coordinates));
}
function coordinatesFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.Coordinates$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'Coordinates' from JSON`);
}
//# sourceMappingURL=coordinates.js.map